import { Injectable } from '@angular/core';
import { CoordinationResultsResponse } from '../../models/coordination-results-response';
import { CoordinationResultTreeNode } from '../../components/coordination-results-tree/models/coordination-result-tree-node';
import { FrequencyFormattingService } from '../../../../../../core/services/frequency-formatting/frequency-formatting.service';
import { CoordinationResultScheduleDAndH } from '../../components/coordination-result-schedule-d-and-h-info/models/coordination-result-schedule-d-and-h';

@Injectable({
    providedIn: 'root',
})
export class CoordinationResultsTreeService {
    constructor(
        private readonly frequencyFormattingService: FrequencyFormattingService,
    ) {}

    /**
     * Will find the matching location, antenna, and frequency for the given node in the response
     * @param response
     * @param node
     * @returns
     */
    findMatchingScheduleDAndH(
        response: CoordinationResultsResponse | null,
        node: CoordinationResultTreeNode,
    ): CoordinationResultScheduleDAndH | null {
        let result: CoordinationResultScheduleDAndH | null = null;

        response?.locations.forEach((location) => {
            location.antennas.forEach((antenna) => {
                antenna.frequencies.forEach((frequency) => {
                    if (frequency.id === node.id) {
                        result = {
                            location: location,
                            antenna: antenna,
                            frequency: frequency,
                        };
                    }
                });
            });
        });

        return result;
    }

    /**
     * Transforms the coordination results response to tree data
     * @param response
     * @returns the node list for the tree
     */
    transformCoordinationResultResponseToTreeData(
        response: CoordinationResultsResponse | null,
    ): CoordinationResultTreeNode[] {
        return (
            response?.locations.map((location) => {
                const data: CoordinationResultTreeNode = {
                    id: location.id,
                    name: `Location ${location.number}`,
                    children: location.antennas.map((antenna) => {
                        return {
                            id: antenna.id,
                            name: `Antenna ${antenna.number}`,
                            children: antenna.frequencies
                                .sort((a, b) => a.frequencyLow - b.frequencyLow)
                                .map((frequency) => {
                                    return {
                                        id: frequency.id,
                                        name: this.frequencyFormattingService.getFrequencyLabel(
                                            frequency.frequencyLow,
                                            frequency.frequencyHigh,
                                        ),
                                    };
                                }),
                        };
                    }),
                };

                return data;
            }) ?? []
        );
    }
}
